import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { Subscription } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { UserService } from '../../operator/user-service/user.service';
import { CompanyService } from '../../shared/services/company/company.service';
import { MultiBuyerCmp } from '../../shared/interfaces/company.interface';

@Component({
  selector: 'ps-multi-buyer-modal',
  templateUrl: './multi-buyer-modal.component.html',
  styleUrls: ['./multi-buyer-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class MultiBuyerModalComponent implements OnInit, OnDestroy {
  multiBuyersCmpsList: MultiBuyerCmp[] = [];
  selectedCompany?: MultiBuyerCmp;
  private _subscriptions: Subscription = new Subscription();

  constructor(
    @Inject(ModalData)
    private _modalData: {
      cmpId: number;
      buyerCompanyId?: number;
    },
    private _modalRef: ModalRef<MultiBuyerModalComponent, string>,
    private _companyService: CompanyService,
    private _userService: UserService,
    private _auth: AuthService,
    private _toastr: ToasterService
  ) {}

  ngOnInit(): void {
    this._auth.selectedMultiBuyerCompany$.subscribe(() => {
      this.selectedCompany = this._auth.selectedMultiBuyerCompany;
    });
    this._getMultiBuyersCmpsList();
  }

  _getMultiBuyersCmpsList() {
    const getBuyers = this._companyService
      .getMultiBuyerCmpsList(
        this._modalData.cmpId,
        this._modalData.buyerCompanyId
      )
      .subscribe(
        (buyersCmps: MultiBuyerCmp[]) => {
          if (!buyersCmps.length) {
            console.error(
              'No valid company found applicable for MultiBuyer selection.'
            );
            this._modalRef.close();
          }
          if (this._modalData.buyerCompanyId) {
            this.selectedCompany = buyersCmps[0];
            this.setBuyerDetails();
          }
          this.multiBuyersCmpsList = buyersCmps;
        },
        (error) => {
          this._toastr.error(error.error.msg);
        }
      );
    this._subscriptions.add(getBuyers);
  }

  clearBuyer() {
    this.selectedCompany = undefined;
  }

  setBuyerDetails() {
    if (!this.selectedCompany?.id) {
      this._auth.resetMultiBuyerToken();
      this._modalRef.close();
    } else {
      const getMultiBuyerToken = this._userService
        .getToken(this.selectedCompany.apiUserId, false)
        .subscribe(
          (response: { token: string }) => {
            this._auth.setSelectedMultiBuyerCompanyData(
              {
                ...response,
                ...this.selectedCompany!,
                parentCompany: this._modalData.cmpId,
              },
              this.selectedCompany!.id
            );
            this._modalRef.close();
          },
          (error) => {
            this._toastr.error(error.error.msg);
          }
        );
      this._subscriptions.add(getMultiBuyerToken);
    }
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }
}
